// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__3grYQ","closePage":"home_closePage__1wNIP"};